// extracted by mini-css-extract-plugin
export default {"status":"SubscriptionStatus_status__EgiPz","free":"SubscriptionStatus_free__mA6J3","premium":"SubscriptionStatus_premium__cxPBN"};